import { useQuery } from '@apollo/client';

import { GetProductRatingSummaryDocument } from 'src/gql/graphql';
import type { GetProductRatingSummaryQuery } from 'src/gql/graphql';

export type ProductRatingSummary = NonNullable<GetProductRatingSummaryQuery['getProductRatingSummary']>;

type UseProductRatingSummaryArgs = {
  productId?: string | null;
  skip?: boolean;
};

type UseProductRatingSummaryResult = {
  summary: ProductRatingSummary | null;
  reviewCount: number;
  loading: boolean;
};

export function useProductRatingSummary({
  productId,
  skip = false,
}: UseProductRatingSummaryArgs): UseProductRatingSummaryResult {
  // Called from both the PDP title rating (index.jsx) and the CustomerReviews
  // card; `cache-first` means the second caller hits Apollo's cache rather than
  // firing a duplicate request for the same product.
  const { data, loading } = useQuery(GetProductRatingSummaryDocument, {
    variables: { productId: productId ?? '' },
    skip: skip || !productId,
    fetchPolicy: 'cache-first',
  });

  const summary = data?.getProductRatingSummary ?? null;

  return {
    summary,
    reviewCount: summary?.reviewCount ?? 0,
    loading,
  };
}
